import { useQuery } from "@tanstack/react-query";
import { queryKeys } from "@/api/query-keys";
import { getConversationDetail } from "../api/conversationThread";

/** The open conversation's thread. Disabled on the welcome route (`id` null). */
export function useConversationDetail(id: string | null) {
  return useQuery({
    queryKey: queryKeys.conversations.detail(id ?? "__none__"),
    queryFn: () => getConversationDetail(id as string),
    enabled: id !== null,
  });
}
